
import React, { useState ,useEffect} from 'react';
import {useNavigate } from 'react-router-dom';
import {Row, Table} from 'antd';
import Title from 'antd/es/skeleton/Title';
import { viewSalesDetailsBasedOnStatus} from '../service/UserDetails';
import { render } from '@testing-library/react';
import Item from 'antd/es/list/Item';
import App from '../App';
import moment from 'moment';
import { Divider } from 'antd';

function SoldRenewal(){
    const navigator = useNavigate();
    const [user, setUser] = useState({ role: 'sales',});

    const handleClick = event=>{
        
        navigator('/sales-lead',{state:{findUser: event,user:user, isEdit: true  }});

    }

  

    // const loadMasterData = async () => {
    //     const response =await masterSource();
    //     const meterOpt = [];
    //     response.data.meter_types.map(item=>  meterOpt.push({label: item.meter_type,value: item.id}))
    //     setMeterTypeOption(meterOpt);
        
    //  }
const [dataSource, setDataSource]= useState([
]) 



const callBackResponse = async () => {


   const status =11;
        
  await viewSalesDetailsBasedOnStatus(status)
  .then(res => 
   {
       
       const mappedData = res.data.data;
       
       setDataSource(mappedData);
   })
  .catch(err => 
   {
       
       if(err.response.data.error === "No leads found with the provided filters"){
           
       }
   })
} 

useEffect(()=>{

    callBackResponse();

  },[]);


  const columns = [
      {
          key: 'id',
          title: 'Lead ID',
          dataIndex: 'id',
          width: 150,
          render: id => id,
      },
      {
          title: 'Lead Date',
          render: () => null,
          width: 150
      },
      {
          title: 'Distribution Date',
          render: () => null,
          width: 150
      },
      {
          title: 'Business Name',
          render: () => null,
          width: 150
      },
      {
          title: 'Customer Name',
          render: () => null,
          width: 150
      },
      {
          title: 'Billing Address',
          render: () => null,
          width: 150
      },
      {
          title: 'Billing Postcode',
          render: () => null,
          width: 150
      },
      {
          title: 'Contact Number',
          render: () => null,
          width: 150
      },
      {
          title: 'Email Address',
          render: () => null,
          width: 150
      },
      {
          title: 'Product',
          render: () => null,
          width: 150
      },
      {
          title: 'Electricity Current Supplier',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric Account Number',
          render: () => null,
          width: 150
      },
      {
          title: 'Supply Number',
          render: () => null,
          width: 170
      },
      {
          title: 'Electric MSN',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric Contract End Date',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric EAC',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric Billing Amount',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric Billing Frequency',
          render: () => null,
          width: 150
      },
      {
          title: 'Electricity Meter Type',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric Standing Charge',
          render: () => null,
          width: 150
      },
      {
          title: 'Electric Unit Rate',
          render: () => null,
          width: 150
      },
      {
          title: 'Night Rate',
          render: () => null,
          width: 150
      },
      {
          title: 'Eve Weekend',
          render: () => null,
          width: 150
      },
      {
          title: 'Capacity Charge',
          render: () => null,
          width: 150
      },
      {
          title: 'FIT Charge',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Current Supplier',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Account Number',
          render: () => null,
          width: 150
      },
      {
          title: 'MPR Number',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas MSN',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Contract End Date',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas EAC',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Billing Amount',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Meter Type',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Standing Charge',
          render: () => null,
          width: 150
      },
      {
          title: 'Gas Unit Rate',
          render: () => null,
          width: 150
      },
      {
          title: 'Lead Status',
          render: () => null,
          width: 150
      },
      {
          title: 'Sales Lead Status',
          render: () => null,
          width: 150
      },
      {
          title: 'Call Back Date',
          render: () => null,
          width: 150
      }
  ];
  
    return(
    <div className='callbacktable'>
         <Divider variant="dotted" style={{ borderColor: '#7cb305' }}>Sold Renewal details for Sales Leads</Divider>
        <header className='callbacktable-header'>
            {/* {
                <p>dataSource: {[dataSource]}</p>
            } */}
       <Table columns={columns}
       bordered
       //title={() => 'Call Back Data For Survey Agent'}
        dataSource={dataSource
        //    dataSource.map((curData) => {
        //    const {agent_id} = curData;
        //    const {business_name,billing_address} = curData.attributes;
           
        //    })
        }
        pagination={{ pageSize: 100 }}
       scroll={{ y: 500 }}
       
       onRow={(record, rowIndex) => {
        return {
        
            handleClick: event => {
        //     handleClick(record);
          }, 
         
        };
      }}
      >
       </Table>
        </header>
    </div>
    );
}

export default SoldRenewal;